export const getTypeOfAlgo = (state) => state.type.typeOfAlgo